import React, { useContext } from 'react';
import { BasketContext } from '../../providers/BasketContext';
import { UserContext } from '../../providers/UserContext';
import { WalesContext } from '../../providers/WalesContext';
import { formatDateFromSFDC } from '../../helpers/utils/generic';
import Card from '../../components/atoms/Card/Card';
import './ApplicationComplete.scss';

const ApplicationComplete = () => {
  const {
    basketData: {
      unitName,
      bedrooms,
      furnished,
      moveInDate,
      periodicity,
      term,
      breakClause,
      agreementType,
    },
  } = useContext(BasketContext);

  const { isCompanyLet } = useContext(UserContext);
  const { isWales } = useContext(WalesContext);

  const shouldShowContractFields = (
    isWales
    || isCompanyLet
    || /live work|non-housing|nha|occupation contract/i.test(agreementType || '')
  );

  return (
    <div className="applicationComplete">
      <p className="applicationComplete__intro"><strong>You have now successfully completed the application for your new home.</strong></p>

      <p className="applicationComplete__description">Please see confirmation below outlining the details of your new home:</p>

      <div className="applicationComplete__card">
        <Card>
          <div className="applicationComplete__content">
            <div className="applicationComplete__terms">
              <h4>FULL ADDRESS</h4>
              <p className="unit-attribute">{unitName || '-'}</p>
              <h4>BEDROOMS</h4>
              <p className="unit-attribute">{bedrooms || '-'}</p>
              <h4>FURNISHED/UNFURNISHED</h4>
              <p className="unit-attribute">{furnished || '-'}</p>
              <h4>START DATE</h4>
              <p className="unit-attribute">{moveInDate ? formatDateFromSFDC(moveInDate) : '-'}</p>
              <h4>PAYMENT PERIODICITY</h4>
              <p className="unit-attribute">{periodicity || '-'}</p>

              {shouldShowContractFields && (
                <>
                  <h4>TERM</h4>
                  <p className="unit-attribute">{term || '-'}</p>
                  <h4>BREAK CLAUSE</h4>
                  <p className="unit-attribute">{breakClause || '-'}</p>
                </>
              )}
            </div>
          </div>
        </Card>
      </div>

      <p className="applicationComplete__outro"><strong>A member of the team will be touch to discuss the next steps, however if you have any queries, please call us on 0191 2424828.</strong></p>
    </div>
  );
};

export default ApplicationComplete;
